export type CriterioKey =
  | 'alinhamentoEstrategico'
  | 'impactoMensuravel'
  | 'inovacaoCriatividade'
  | 'escalabilidadeSustentabilidade';

export interface NotasCriterios {
  alinhamentoEstrategico: number;
  impactoMensuravel: number;
  inovacaoCriatividade: number;
  escalabilidadeSustentabilidade: number;
}

export interface AvaliacaoIniciativa {
  iniciativaId: string;
  iniciativaTitulo: string;
  notas: NotasCriterios;
  total: number;
}

export interface AvaliacaoEtapa2 {
  _id: string;
  category: string;
  avaliadorId: string;
  avaliadorName: string;
  avaliadorMatricula: string;
  enviadoEm: number;
  avaliacoes: AvaliacaoIniciativa[];
  totalIniciativas: number;
  supersededAt?: number;
}

export type AvaliacaoEtapa2Input = Omit<AvaliacaoEtapa2, '_id' | 'supersededAt'>;

export const CRITERIOS_KEYS: CriterioKey[] = [
  'alinhamentoEstrategico',
  'impactoMensuravel',
  'inovacaoCriatividade',
  'escalabilidadeSustentabilidade',
];

export const criarNotasVazias = (): Partial<NotasCriterios> => ({});

export const isAvaliacaoCompleta = (
  notas: Partial<NotasCriterios> | undefined
): notas is NotasCriterios => {
  if (!notas) return false;
  return CRITERIOS_KEYS.every(
    (k) => typeof notas[k] === 'number' && notas[k]! >= 0 && notas[k]! <= 10
  );
};

export const calcularTotalNotas = (
  notas: Partial<NotasCriterios> | undefined
): number => {
  if (!notas) return 0;
  return CRITERIOS_KEYS.reduce((acc, k) => acc + (notas[k] ?? 0), 0);
};

export type AvaliacoesMap = Record<string, Partial<NotasCriterios> | undefined>;
